<nav class="sidebar d-lg-block" [class.sidebar-open]="isSidebarOpen" aria-label="Menú lateral">
  <ul class="nav flex-column pb-5">

    <!-- Toggle -->
    <li class="nav-item close-item">
      <button type="button" class="nav-link mt-3 body-m" (click)="closeSidebar($event)"
        [attr.aria-expanded]="isSidebarOpen" [title]="isSidebarOpen ? 'Cerrar' : 'Abrir'">
        <span *ngIf="!isSidebarOpen"><i class="bi bi-list"></i></span>
        <span *ngIf="isSidebarOpen"><i class="bi bi-x-lg"></i></span>
      </button>
    </li>

    <!-- Inicio (exacto) -->
    <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <a class="nav-link body-m" routerLink="/inicio" (click)="closeSidebar()" title="Inicio" aria-current="page">
        <span><i class="bi bi-house"></i></span>
        <span *ngIf="isSidebarOpen">Inicio</span>
      </a>
    </li>

    <!-- Ítems -->
    <li class="nav-item" *ngFor="let item of sidebarItems; trackBy: trackByRuta"
      [ngClass]="{'has-children': item.children?.length}">
      <div class="d-flex align-items-center">
        <!-- Link principal: si tiene children mostramos un botón que expande/contrae;
             si no tiene children mostramos el enlace normal que navega. -->
        <button *ngIf="item.ruta && item.children?.length" type="button"
          class="nav-link body-m flex-grow-1 btn-toggle-parent" (click)="toggleExpand(item, $event)"
          [attr.aria-expanded]="isExpanded(item)" [title]="item.alt">
          <span><i class="bi" [ngClass]="item.icono"></i></span>
          <span *ngIf="isSidebarOpen" class="ms-2">{{ item.label }}</span>
        </button>

        <a *ngIf="item.ruta && !(item.children?.length)" class="nav-link body-m flex-grow-1" [routerLink]="item.ruta"
          routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onNavClick()"
          [title]="item.alt">
          <span><i class="bi" [ngClass]="item.icono"></i></span>
          <span *ngIf="isSidebarOpen" class="ms-2">{{ item.label }}</span>
        </a>

        <!-- Si no tiene ruta mostramos solo el label -->
        <div *ngIf="!item.ruta" class="nav-link body-m flex-grow-1" title="{{item.alt}}">
          <span><i class="bi" [ngClass]="item.icono"></i></span>
          <span *ngIf="isSidebarOpen" class="ms-2">{{ item.label }}</span>
        </div>

        <!-- Botón para expandir hijos (si existen). Se oculta cuando el sidebar está cerrado -->
        <button *ngIf="item.children?.length && isSidebarOpen" type="button" class="btn btn-link btn-sm toggle-children"
          (click)="toggleExpand(item, $event)" [attr.aria-expanded]="isExpanded(item)"
          [title]="isExpanded(item) ? 'Ocultar' : 'Mostrar'">
          <i class="bi" [ngClass]="isExpanded(item) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </button>
      </div>

      <!-- Submenu -->
      <ul *ngIf="item.children?.length" class="nav flex-column ms-3" [class.show]="isExpanded(item)"
        [attr.aria-hidden]="!isExpanded(item)">
        <li class="nav-item" *ngFor="let child of item.children; trackBy: trackByRuta" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link body-m" [routerLink]="child.ruta" (click)="onNavClick()" [title]="child.alt">
            <span><i class="bi" [ngClass]="child.icono"></i></span>
            <span *ngIf="isSidebarOpen" class="ms-2">{{ child.label }}</span>
          </a>
        </li>
      </ul>
    </li>

  </ul>
</nav>